/** Fallback when API config and env are unset (local patient portal default port). */
export const DEFAULT_TELECONSULT_PATIENT_PORTAL_ORIGIN = 'http://localhost:3010';

export function patientPortalOriginFromEnv(): string {
  const fromEnv = (process.env.REACT_APP_TELECONSULT_PATIENT_PORTAL_ORIGIN || '').trim();
  return (fromEnv || DEFAULT_TELECONSULT_PATIENT_PORTAL_ORIGIN).replace(/\/$/, '');
}
